import {shim} from "../helpers/shim";


export class Flickity {

   private timer: number | undefined;
   
    loadScript = (callback: () => void) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (typeof (shim('Flickity')) === 'undefined') {
                if (document.querySelectorAll('#flickity-js').length <= 0) {
                    let tag = document.createElement('script');
                    tag.src = '/resources/lib/flickity.pkgd.min.js';
                    tag.id = 'flickity-js';
                    let firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
                }
                console.log('Flickity not loaded');
                this.loadScript(callback);
            } else {
                console.log('Flickity loaded');
                callback();
            }
        }, 50);
    }
    
}